import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const BucketSchema = z.object({
  upperBound: z.number().int(), // Allow -1 for catch-all bucket
  price: z.number().nonnegative(),
  currency: z.string(),
  skuCount: z.number().int().nonnegative(),
});

const BucketInputSchema = z.object({
  upperBound: z
    .number()
    .int()
    .refine((val) => val === -1 || val > 0, {
      message: "Upper bound must be -1 (catch-all) or positive",
    }),
  price: z.number().nonnegative(),
  currency: z.string(),
});

export const getForecastingCostBreakdown = unaryRpc({
  name: "getForecastingCostBreakdown" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ buckets: z.array(BucketSchema) }),
});

export const saveForecastingCostBreakdown = unaryRpc({
  name: "saveForecastingCostBreakdown" as const,
  input: z.object({ teamId: z.string(), buckets: z.array(BucketInputSchema) }),
  output: z.object({ success: z.boolean(), buckets: z.array(BucketSchema) }),
});
